<template>
  <div class="combo-container">
    <p class="consult">添加红娘微信咨询以下服务</p>
    <img src="/static/img/wechat-person.jpeg" alt="" class="consult-code" />
    <p class="consult-tips">长按识别二维码，好友验证请备注你的信息：</p>
    <p class="consult-tips">ID+城市+学历+工作+公司</p>

    <div class="combo">
      <span class="index">1</span>
      <h3 class="title">发帖上榜，迅速脱单（免费/有门槛）</h3>
      <p class="item">资料齐全且通过全部实名认证后，可联系红娘豆子姐申请免费在公众号等官方渠道上榜发帖，让更多的单身异性看到你。</p>
      <p class="item"><strong>门槛：</strong>对发帖者的学历/工作/年龄/收入/颜值以及身高有一定的要求和审核。</p>
      <p class="item"><strong>福利：</strong>实名认证且发帖后，系统将额外再赠送5个喜欢名额（14天有效）。</p>
    </div>
    <div class="combo">
      <span class="index">2</span>
      <h3 class="title">申请加入实名单身群（免费/有门槛）</h3>
      <p class="item">资料齐全且通过全部实名认证后，可以联系红娘豆子姐，申请免费加入实名单身群，具体入群详情可咨询红娘豆子姐。</p>
    </div>
    <div class="combo">
      <span class="index">3</span>
      <h3 class="title">一对一线下约会（付费服务）</h3>
      <p class="item">当对平台的某个异性有好感时，若希望快速的推进情感状态，可直接联系豆姐帮忙安排线下一对一的约会。</p>
    </div>

    <div class="official">
      <p class="tips">关注公众号 <span class="official-name">hello部落</span></p>
      <img src="/static/img/wechat-public.jpeg" alt="" class="official-code" />
      <p class="consult-tips">线上交友丨单身活动丨名企联谊</p>
      <p class="consult-tips">优质单身男女推荐</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'combo'
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.combo-container {
  padding: 20px 40px 60px;
  .combo {
    position: relative;
    margin-top: 32px;
    padding: 20px 16px 20px 86px;
    background: #f4f4f4;
  }
  .index {
    position: absolute;
    top: 0;
    left: 0;
    padding: 0 16px 16px 0;
    width: 66px;
    height: 66px;
    color: #fff;
    line-height: 50px;
    text-align: center;
    background: url("~@/assets/img/combo-index.png") no-repeat;
    background-size: 100%;
  }
  .title {
    margin-bottom: 10px;
    font-size: 32px;
    line-height: 44px;
  }
  .item {
    font-size: 24px;
    line-height: 44px;
  }
  .consult {
    color: $mainColor;
    font-size: 28px;
    line-height: 44px;
    text-align: center;
  }
  .consult-code {
    margin: 20px auto 10px;
    display: block;
    width: 220px;
    height: 220px;
  }
  .consult-tips {
    color: #9b9b9b;
    text-align: center;
  }
  .official {
    margin-top: 60px;
    text-align: center;
    .tips {
      color: #9b9b9b;
    }
    .official-name {
      color: #4a4a4a;
    }
    .official-code {
      display: block;
      margin: 15px auto 0;
      width: 220px;
      height: 220px;
    }
  }
}
</style>
